import { getLanguage, setLanguage, t, Language } from '../i18n/translations';

export class Navbar {
  public onLanguageChanged?: (lang: Language) => void;
  public onThemeToggle?: () => void;

  public render(container: HTMLElement) {
    const isDark = document.body.classList.contains('theme-dark');
    const currentLang = getLanguage();

    container.innerHTML = `
      <nav class="landing-nav">
        <a href="/" class="brand-logo">
          <div class="brand-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="23 7 16 12 23 17 23 7"></polygon>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
            </svg>
          </div>
          <span>${t('brandName')}</span>
        </a>

        <div style="display: flex; align-items: center; gap: 12px;">
          <!-- Language Selector -->
          <div style="display: flex; background: var(--bg-surface-elevated); border: 1px solid var(--border-subtle); border-radius: var(--radius-full); padding: 2px;">
            <button id="lang-en" style="border: none; background: ${currentLang === 'en' ? 'var(--brand-primary)' : 'transparent'}; color: ${currentLang === 'en' ? 'white' : 'var(--text-secondary)'}; font-weight: 600; padding: 4px 10px; border-radius: var(--radius-full); cursor: pointer; font-size: 0.8rem;">EN</button>
            <button id="lang-bn" style="border: none; background: ${currentLang === 'bn' ? 'var(--brand-primary)' : 'transparent'}; color: ${currentLang === 'bn' ? 'white' : 'var(--text-secondary)'}; font-weight: 600; padding: 4px 10px; border-radius: var(--radius-full); cursor: pointer; font-size: 0.8rem;">বাংলা</button>
          </div>

          <!-- Theme Toggle -->
          <button id="btn-theme-toggle" class="control-btn" style="width: 36px; height: 36px;" title="Toggle Theme">
            ${isDark ? `
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            ` : `
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
            `}
          </button>
        </div>
      </nav>
    `;

    container.querySelector('#lang-en')?.addEventListener('click', () => {
      setLanguage('en');
      if (this.onLanguageChanged) this.onLanguageChanged('en');
    });

    container.querySelector('#lang-bn')?.addEventListener('click', () => {
      setLanguage('bn');
      if (this.onLanguageChanged) this.onLanguageChanged('bn');
    });

    container.querySelector('#btn-theme-toggle')?.addEventListener('click', () => {
      if (document.body.classList.contains('theme-dark')) {
        document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-light');
      } else {
        document.body.classList.remove('theme-light');
        document.body.classList.add('theme-dark');
      }
      this.render(container);
      if (this.onThemeToggle) this.onThemeToggle();
    });
  }
}
